import { render, staticRenderFns } from "./ModerateInstagramInteraction.vue?vue&type=template&id=ddb5ef12&scoped=true&"
import script from "./ModerateInstagramInteraction.vue?vue&type=script&lang=js&"
export * from "./ModerateInstagramInteraction.vue?vue&type=script&lang=js&"
import style0 from "./ModerateInstagramInteraction.vue?vue&type=style&index=0&id=ddb5ef12&lang=scss&scoped=true&"
import style1 from "./ModerateInstagramInteraction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb5ef12",
  null
  
)

export default component.exports